module.exports = __webpack_public_path__ + "img/Firing_stock.222e3998.svg";